/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrivateBankingProductCatalogueResponse } from './PrivateBankingProductCatalogueResponse';
import {
    PrivateBankingProductCatalogueResponseFromJSON,
    PrivateBankingProductCatalogueResponseFromJSONTyped,
    PrivateBankingProductCatalogueResponseToJSON,
    PrivateBankingProductCatalogueResponseToJSONTyped,
} from './PrivateBankingProductCatalogueResponse';

/**
 * Contains the result of the database fetch from Service Definition table
 * @export
 * @interface PrivateBankingProductCatalogueListResult
 */
export interface PrivateBankingProductCatalogueListResult {
    /**
     * Products data that can be shown to the user
     * @type {Array<PrivateBankingProductCatalogueResponse>}
     * @memberof PrivateBankingProductCatalogueListResult
     */
    products?: Array<PrivateBankingProductCatalogueResponse>;
}

/**
 * Check if a given object implements the PrivateBankingProductCatalogueListResult interface.
 */
export function instanceOfPrivateBankingProductCatalogueListResult(value: object): value is PrivateBankingProductCatalogueListResult {
    return true;
}

export function PrivateBankingProductCatalogueListResultFromJSON(json: any): PrivateBankingProductCatalogueListResult {
    return PrivateBankingProductCatalogueListResultFromJSONTyped(json, false);
}

export function PrivateBankingProductCatalogueListResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateBankingProductCatalogueListResult {
    if (json == null) {
        return json;
    }
    return {
        
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(PrivateBankingProductCatalogueResponseFromJSON)),
    };
}

export function PrivateBankingProductCatalogueListResultToJSON(json: any): PrivateBankingProductCatalogueListResult {
    return PrivateBankingProductCatalogueListResultToJSONTyped(json, false);
}

export function PrivateBankingProductCatalogueListResultToJSONTyped(value?: PrivateBankingProductCatalogueListResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(PrivateBankingProductCatalogueResponseToJSON)),
    };
}

